import { getMainInternshipsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainInternshipsSearchRoutePath';
import { getMainJobsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainJobsSearchRoutePath';
import { getMainOrgSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainOrgSearchRoutePath';

import { FindAJobDropdownData } from './FindAJobDropdownData';

export const findAJobDropdownDataPt: FindAJobDropdownData = {
  triggerText: 'Busca',
  triggerHref: getMainJobsSearchRoutePath({ lang: 'pt' }),
  search: {
    title: 'Search',
    items: [
      {
        type: 'job',
        icon: 'briefcase',
        title: 'Empregos',
        href: getMainJobsSearchRoutePath({ lang: 'pt' }),
      },
      {
        type: 'internship',
        icon: 'sign-path',
        title: 'Estágios',
        href: getMainInternshipsSearchRoutePath({ lang: 'pt' }),
      },
      {
        type: 'org',
        icon: 'building',
        title: 'Organizações',
        href: getMainOrgSearchRoutePath({ lang: 'pt' }),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        image: 'illustrations/article-illustration.svg',
        title: 'Blog Carreira de Impacto',
        description:
          'Inspirações e dicas para guiar sua jornada profissional no setor social.',
        href: '/pt/carreira-impacto',
      },
    ],
  },
};
